import {
    ButtonPrimary,
    ButtonFixedFooterLayout,
    Text3,
    BoxedRow,
    RadioButton,
    RadioGroup,
    NavigationBar,
    skinVars,
    Text5,
    useWindowSize,
    IconInformationUserRegular,
} from '@telefonica/mistica';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import './index.scss';
import { AxiosError } from 'axios';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { sendEscalationOTP } from '../../../../services/EscalationService';
import { setInfoError } from '../../../../utils/dataTransformation/errorMesssages';
import { TrackingEvents } from '../../../../utils/dataTransformation/tracking';
import {
    formatMobileNumber,
    hideEmailCharacters,
    hideMobileCharacters,
} from '../../../../utils/dataTransformation/unitsConversion';
import { isWebviewAndroid, isWebviewIOS } from '../../../../utils/navigation/controlDevices';
import navigateParams from '../../../../utils/navigation/navigateParams';
import EscalationContactsVerify from '../validateOtp';
import HeaderProfile from '../../../../components/HeaderProfile';
import { HeaderConfigureLine } from '../../../../components/HeaderConfigureLine';
import { Callout } from '@telefonica/mistica';

export interface EscalationContactsInterface {
    fromDesktop?: boolean;
    setComponentSelected?: any;
    flowDesktop?: string;
    contactsDesktop?: any;
}

const EscalationContacts: React.FC<EscalationContactsInterface> = ({
    fromDesktop,
    setComponentSelected,
    flowDesktop,
    contactsDesktop,
}) => {
    const { t } = useTranslation();
    const { trackingScreenView } = new TrackingEvents();
    const navigate = useNavigate();
    const size = useWindowSize();
    const [valueVerification, setValueVerification] = useState<any>('');
    const typeOfContact = valueVerification.includes('@') ? 'email' : 'mobile';
    const [params] = useSearchParams();
    const pattern = /"|]/gi;
    const contactsRegex = fromDesktop
        ? contactsDesktop
        : params.get('contacts')!.replaceAll(pattern, '').replaceAll('[', '').replaceAll(' ', '') || '';
    const contacts: string[] = fromDesktop ? contactsDesktop : contactsRegex.split(',');
    const flow = fromDesktop ? flowDesktop : params.get('flow')!;

    const sendToNative = (url: string, type: string, title?: string, err?: any, description?: string) => {
        if (url === '/escalation/otp/feedback') {
            const feedbackData = {
                stateFeedback: description,
                err: err,
            };
            const queryParams = {
                stateFeedback: description,
                err: err,
            };
            if (navigateParams(type, url, queryParams, {}, title)) {
                navigate(url, { state: feedbackData });
            }
        } else {
            const queryParams = {
                type: typeOfContact,
                flow: flow,
                contact: valueVerification,
            };
            if (navigateParams(type, url, queryParams, {}, title)) {
                navigate(
                    url + '?type=' + typeOfContact + '&flow=' + flow + '&contact=' + valueVerification,
                    valueVerification,
                );
            }
        }
    };

    const escalationOTPSend = () => {
        const data: any = { contact: valueVerification };
        sendEscalationOTP(data)
            .then(() => {
                if (fromDesktop) {
                    setComponentSelected(
                        <EscalationContactsVerify
                            fromDesktop={fromDesktop}
                            setComponentSelected={setComponentSelected}
                            flowDesktop={flow}
                            contactDesktop={valueVerification}
                            contactsDesktop={contacts}
                            typeMediumDesktop={typeOfContact}
                        ></EscalationContactsVerify>,
                    );
                } else {
                    sendToNative('/escalation/contacts/verify', 'modeFlow-backgroundBlue', t('verificadeCode'));
                }
            })
            .catch((error: AxiosError) => {
                sendToNative('/escalation/otp/feedback', 'feedback-error', '', setInfoError(error), 'ERROR');
            });
    };

    useEffect(() => {
        if (!(isWebviewAndroid || isWebviewIOS)) {
            trackingScreenView();
        }
    }, []);

    if (size.width >= 1024) {
        return (
            <div className='desktop-update-contacts-escalation'>
                {flow === 'changePassword' && (
                    <HeaderProfile
                        title={t('profileChangePassword')}
                        breadcrumbs={[{ title: t('profileTitle'), url: '/profile' }]}
                    />
                )}

                {flow === 'mobile' && (
                    <HeaderProfile
                        title={t('personalDataUpdateMobileTitle')}
                        breadcrumbs={[
                            { title: t('profileTitle'), url: '/profile' },
                            { title: t('personalDataTitle2'), url: '/profile/personal-data' },
                        ]}
                    />
                )}

                {flow === 'email' && (
                    <HeaderProfile
                        title={t('personalDataUpdateEmailTitle')}
                        breadcrumbs={[
                            { title: t('profileTitle'), url: '/profile' },
                            { title: t('personalDataTitle2'), url: '/profile/personal-data' },
                        ]}
                    />
                )}

                {flow === 'bankAccount' && (
                    <HeaderProfile
                        title={t('supportContentRowChangeBankAccount')}
                        breadcrumbs={[
                            { title: t('profileTitle'), url: '/profile' },
                            { title: t('personalDataTitle2'), url: '/profile/personal-data' },
                        ]}
                    />
                )}

                {flow === 'supportChangeBankAccount' && (
                    <HeaderProfile
                        title={t('supportContentRowChangeBankAccount')}
                        breadcrumbs={[{ title: t('breadcrumbsSupport'), url: '/support' }]}
                    />
                )}

                {flow === 'eSim' && <HeaderConfigureLine />}

                <div
                    className='update-contacts-escalation'
                    style={{
                        padding: size.width >= 1220 ? '40px 680px 0 104px' : '40px 416px 0 40px',
                    }}
                >
                    <div className='update-contacts-escalation__title'>
                        <Text5>{t('otpFlowTitle')}</Text5>
                    </div>
                    <div className='update-contacts-escalation__subtitle'>
                        <Text3 regular color={skinVars.colors.textPrimary}>
                            {t('descriptionEscalationTitle')}
                        </Text3>
                    </div>
                    <div className='update-contacts-escalation__radioGroup'>
                        <RadioGroup name={'verification'} value={valueVerification} onChange={setValueVerification}>
                            {contacts?.map((contact: string, index: number) => {
                                const _contact = contact.includes('@') ? 'email' : 'mobile';
                                return (
                                    <div className='update-contacts-escalation__radioGroup__boxedRow' key={index}>
                                        <BoxedRow
                                            title={
                                                _contact === 'email' ? t('personalDataEmail') : t('personalDataMobile')
                                            }
                                            description={
                                                _contact === 'mobile'
                                                    ? formatMobileNumber(contact)
                                                    : hideEmailCharacters(contact)
                                            }
                                            right={
                                                <div className='update-contacts-escalation__radioGroup__boxedRow__radioButton'>
                                                    <RadioButton value={contact}></RadioButton>
                                                </div>
                                            }
                                        ></BoxedRow>
                                    </div>
                                );
                            })}
                        </RadioGroup>
                    </div>
                    <div className='update-contacts-escalation__callout'>
                        <Callout
                            icon={<IconInformationUserRegular size={24} color={skinVars.colors.brand} />}
                            description={t('escalationContactsCalloutDescription')}
                        ></Callout>
                    </div>
                    <div className='update-contacts-escalation__buttonPrimary'>
                        <ButtonPrimary
                            disabled={valueVerification === ''}
                            onPress={() => {
                                escalationOTPSend();
                            }}
                        >
                            {t('next')}
                        </ButtonPrimary>
                    </div>
                </div>
            </div>
        );
    } else {
        return (
            <div className='update-contacts-escalation'>
                <ButtonFixedFooterLayout
                    button={
                        <ButtonPrimary
                            disabled={valueVerification === ''}
                            onPress={() => {
                                escalationOTPSend();
                            }}
                        >
                            {t('buttonReceiveCode')}
                        </ButtonPrimary>
                    }
                >
                    {!(isWebviewIOS || isWebviewAndroid) && (
                        <div className='c-customer-agreement-navigationBar'>
                            <NavigationBar
                                isInverse={true}
                                onBack={() => {
                                    navigate(-1);
                                }}
                                title={'Seleccionar medio de contacto'}
                            />
                        </div>
                    )}
                    <div className='update-contacts-escalation__subtitle'>
                        <Text3 regular color={skinVars.colors.textPrimary}>
                            {t('descriptionEscalationTitle')}
                        </Text3>
                    </div>
                    <div className='update-contacts-escalation__radioGroup'>
                        <RadioGroup name={'verification'} value={valueVerification} onChange={setValueVerification}>
                            {contacts?.map((contact: string, index: number) => {
                                const _contact = contact.includes('@') ? 'email' : 'mobile';
                                return (
                                    <div className='update-contacts-escalation__radioGroup__boxedRow' key={index}>
                                        <BoxedRow
                                            title={
                                                _contact === 'email' ? t('personalDataEmail') : t('personalDataMobile')
                                            }
                                            description={
                                                _contact === 'mobile'
                                                    ? hideMobileCharacters(formatMobileNumber(contact))
                                                    : hideEmailCharacters(contact)
                                            }
                                            right={
                                                <div className='update-contacts-escalation__radioGroup__boxedRow__radioButton'>
                                                    <RadioButton value={contact}></RadioButton>
                                                </div>
                                            }
                                        ></BoxedRow>
                                    </div>
                                );
                            })}
                        </RadioGroup>
                    </div>
                    <div className='update-contacts-escalation__callout'>
                        <Callout
                            icon={<IconInformationUserRegular size={24} color={skinVars.colors.brand} />}
                            description={t('escalationContactsCalloutDescription')}
                        ></Callout>
                    </div>
                </ButtonFixedFooterLayout>
            </div>
        );
    }
};

export default EscalationContacts;
